import { del, get, post } from './httpClient';

function readApiMessage(response) {
  const text = response?.error || response?.message;
  const trimmed = typeof text === 'string' ? text.trim() : '';
  return trimmed;
}

/**
 * `GET /getstaffsession` — cualquier JWT. No lista staff. Gate de la consola admin.
 *
 * @param {{ signal?: AbortSignal }} [options]
 */
export function getStaffSession({ signal } = {}) {
  return get('/getstaffsession', { signal });
}

/**
 * @param {object} response Envelope de `httpClient`.
 * @returns {boolean}
 */
export function readIsStaff(response) {
  return response?._httpOk === true && response?.data?.is_staff === true;
}

/**
 * `GET /getterriostaff` — solo staff. Lista el equipo.
 *
 * @param {{ signal?: AbortSignal }} [options]
 */
export function getTerrioStaff({ signal } = {}) {
  return get('/getterriostaff', { signal });
}

/**
 * @param {object} response
 * @returns {Array<{ user_id: string, created_at?: string, created_by?: string|null }>}
 */
export function readStaffList(response) {
  return Array.isArray(response?.data) ? response.data : [];
}

/**
 * `POST /upsertterriostaff` `{ user_id }`. Idempotente. No crea la cuenta Cognito.
 *
 * @param {string} userId Cognito `sub` ya registrado.
 * @param {{ signal?: AbortSignal }} [options]
 */
export function upsertTerrioStaff(userId, { signal } = {}) {
  return post('/upsertterriostaff', {
    body: { user_id: String(userId || '').trim() },
    signal,
  });
}

/**
 * `DELETE /deleteterriostaff?user_id=`
 *
 * @param {string} userId
 * @param {{ signal?: AbortSignal }} [options]
 */
export function deleteTerrioStaff(userId, { signal } = {}) {
  return del('/deleteterriostaff', {
    params: { user_id: String(userId || '').trim() },
    signal,
  });
}

/**
 * Mensaje de UI para mutaciones del ABM staff.
 *
 * @param {number|null} status
 * @param {object} [response]
 * @param {'add'|'remove'} [action]
 */
export function getStaffMutationErrorMessage(status, response, action = 'add') {
  const fromApi = readApiMessage(response);
  if (status === 400) return fromApi || 'Revisá el Cognito sub.';
  if (status === 403 && action === 'remove') {
    return fromApi || 'No podés quitarte a vos ni borrar al último del equipo.';
  }
  if (status === 403) return fromApi || 'No tenés permiso para esta acción.';
  if (status === 404) return fromApi || 'Ese sub no está en el equipo.';
  return fromApi || (action === 'remove' ? 'No se pudo quitar.' : 'No se pudo agregar.');
}
